<template>
  <div class="index">
    <h3 class="buy-title">{{ title }}</h3>
    <!-- <p style="text-align:center;font-size:16px;margin:20px 0;">
      服务咨询，请致电
      <span style="color:#3BC492">18971608045</span>
    </p> -->
    <div class="price-container">
      <div v-for="i in priceList.slice(0, 4)">
        <div class="price-top" style="position: relative">
          <!--          <img v-if="i.packageName=='免费版'" class="discount" src="@/assets/preferential.png" />-->
          <h4>{{ i.packageName }}</h4>
          <h2>
            {{
              i.packageName != "VIP版"
                ? i.price * i.upperLimit +
                  `元/${i.packageName != "免费版" ? "年" : "月"}`
                : "按需付款"
            }}
          </h2>
          <span
            v-if="i.packageName == '免费版'"
            class="tobuy"
            @click="handleChosePackage(i)"
            >{{ userInfo.isFree ? "申请" : "已申请" }}</span
          >
          <span
            v-else
            class="tobuy"
            @click="handleChosePackage(i, serviceList.includes(i.packageName))"
            >{{
              serviceList.includes(i.packageName) ? "继续购买" : "购买"
            }}</span
          >
        </div>
        <div style="height: 340px; position: relative">
          <!--          <p style="position: relative;" v-if="i.packageName=='免费版'">-->
          <!--&lt;!&ndash;            <del>&nbsp;&ndash;&gt;-->
          <!--                50条&nbsp;-->
          <!--&lt;!&ndash;              </del>&ndash;&gt;-->
          <!--&lt;!&ndash;            <span style="font-size: 20px;position: absolute;line-height:20px;color: red;font-weight: 500;white-space: nowrap;margin-left: 10px">限时{{i.lowerLimit}}条</span>&ndash;&gt;-->
          <!--          </p>-->

          <div
            v-if="i.packageName != 'VIP版'"
            style="display: flex; align-items: center; justify-content: center"
          >
            <span style="font-size: 14px">
              {{ i.lowerLimit }}条/{{ i.packageName == "免费版" ? "月" : "年" }}
            </span>
            <div class="notice-box">
              <el-tooltip placement="top" effect="light">
                <div slot="content">如需试用更多条数，请联系客服增加</div>
                <img
                  class="wenhao"
                  v-if="i.packageName == '免费版' ? true : false"
                  src="@/assets/wenhao.png"
                  alt=""
                />
              </el-tooltip>

              <!-- <p v-if="i.packageName == '免费版' ? true : false" class="notice">
                如需适用更多条数，请联系客服增加
              </p> -->
            </div>
          </div>
          <p v-else>根据实际使用数量计费</p>
          <p>{{ i.customTemplate }}个定制模板</p>
          <p>{{ i.defaultTemplate }}个默认模板</p>
          <p>{{ i.recall ? "可撤回" : "不可撤回" }}</p>
          <p>{{ i.resend ? "可重发" : "不可重发" }}</p>
          <p v-if="i.smsNotify">{{ "短信发送" }}</p>
          <p>邮件发送</p>
          <p v-if="i.oaNotify">{{ "OA系统通知" }}</p>
          <p v-if="i.wechatNotify">{{ "微信公众号发送" }}</p>
          <p v-if="i.notice">{{ "发送公告" }}</p>
          <p v-if="i.sign">{{ "手写签收 / 一键签收" }}</p>
        </div>
      </div>
    </div>
    <div class="info">
      <div class="info-title">
        <img src="../assets/jing.png" alt="" />
        <span style="font-weight: 600">短信发送使用说明：</span>
      </div>
      <p>
        1.
        本平台的短信发送服务，仅用于平台的合法付费用户向其存在劳动或劳务关系的员工或职员，或存在其他合法合规的用工关系的人员，或征得同意的信息接收人，发送工资条相关的通知和提醒用途；
      </p>
      <p>
        2.
        验证码短信的发送频率为：同签名同号码，每分钟内发送上限1条，每小时内发送上限5条，每个自然日内发送上限10条；通知短信的发送频率为：同内容同号码，每分钟内发送上限1条，每小时内发送上限10条，每个自然日内发送上限50条；
      </p>
      <p>
        3.
        任何人不得利用本平台对外发送传播宗教、骚扰、推广（包括但不限于投资、理财、股票、收藏品、房地产等）、辱骂、诈骗、色情、淫秽、反动、赌博、暴力、凶杀、恐怖、教唆犯罪以及其他违法违禁信息和垃圾信息；
      </p>
      <p>
        4.
        一经发现任何违规行为，平台将永久封停相关账号权限，并将发送内容及账号注册信息移交相关部门。
      </p>
    </div>
  </div>
</template>

<script>
import Cookie from "js-cookie";

export default {
  name: "index",
  props: {
    title: String,
  },
  components: {},
  data() {
    return {
      priceList: [],
      userInfo: {},
      serviceList: [],
      ownList: [],
    };
  },
  methods: {
    async getServiceList() {
      let res = await this.$http.get(
        `/salary-service/customer/getServiceInfoByCustomer`
      );
      console.log("ccc", res);
      this.ownList = res.data;
      res.data.map((item) => {
        this.serviceList.push(item.serviceType);
      });
      console.log(this.serviceList);
    },
    async getPrice() {
      let res = await this.$http.get("/salary-service/customer/packagePage");
      this.priceList = res.data;
      console.log(res.data);
    },
    async handleChosePackage(i, isrenewal) {
      console.log(this.ownList, "this.ownList");
      if (i.packageName != "免费版") {
        if (isrenewal) {
          switch (i.packageName) {
            case "基础版":
              try {
                this.$store.commit("activeStep", {
                  package: true,
                  packageDetail: i,
                });
                console.log(i);
                this.$router.push({
                  path: "/index/buy",
                  query: {
                    type: "renewal",
                    endtime: this.ownList.filter(
                      (item) => item.serviceType == i.packageName
                    )[0].endTime,
                    starttime: this.ownList.filter(
                      (item) => item.serviceType == i.packageName
                    )[0].beginTime,
                  },
                });
              } catch {}

              break;
            case "高级版":
              try {
                this.$store.commit("activeStep", {
                  package: true,
                  packageDetail: i,
                });
                console.log(i);
                this.$router.push({
                  path: "/index/buy",
                  query: {
                    type: "renewal",
                    endtime: this.ownList.filter(
                      (item) => item.serviceType == i.packageName
                    )[0].endTime,
                    starttime: this.ownList.filter(
                      (item) => item.serviceType == i.packageName
                    )[0].beginTime,
                  },
                });
              } catch {}
              break;
            case "VIP版":
              // let vipList = await this.$http.get(
              //   `salary-service/customer/package/${i.packageName}/name`
              // );

              let vipList = await this.$http.get(
                `salary-service/customer/package/${i.packageName}/name`
              );
              console.log(vipList, "vipList-----------");
              this.$store.commit("handleVip", {
                list: vipList.data,
                detail: vipList.data[0],
              });
              this.$router.push({
                path: "/index/buy",
                query: {
                  type: "renewal",
                  endtime: this.ownList.filter(
                    (item) => item.serviceType == i.packageName
                  )[0].endTime,
                  starttime: this.ownList.filter(
                    (item) => item.serviceType == i.packageName
                  )[0].beginTime,
                },
              });
              break;
          }
        } else {
          if (i.packageName == "VIP版") {
            console.log(this.priceList, "this.priceList");
            this.$store.commit("handleVip", {
              list: this.priceList.slice(3, 6),
              detail: i,
            });
          } else {
            this.$store.commit("activeStep", {
              package: true,
              packageDetail: i,
            });
          }
        }
      } else {
        if (this.userInfo.isFree) {
          this.$http
            .post("salary-service/customer/order/free", {
              content: i.packageName,
              isBalancePay: false,
              balancePayAmount: 0,
              orderNum: i.upperLimit,
              serviceTime: 0,
              // payAmount: 0
            })
            .then((res) => {
              this.$notify({
                title: "成功",
                message: "申请成功，请到我的套餐中查看详情",
                type: "success",
              });
              this.$http.get(`customer/${this.userInfo.id}`).then((res) => {
                Cookie.set("userInfo", res.data);
                this.userInfo = JSON.parse(Cookie.get("userInfo"));
                this.getPrice();
              });
            });
        } else {
          this.$notify({
            title: "失败",
            message: "您已经申请过免费版,不能重复申请",
            type: "warning",
          });
        }
      }
    },
  },
  mounted() {
    this.getPrice();

    this.getServiceList();
  },
};
</script>

<style lang="less" scoped>
.discount {
  position: absolute;
  right: -50px;
  top: -30px;
  width: 100px;
}
.index {
  padding: 32px 0;
  .buy-title {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    margin-top: 20px;
  }
  .price-container {
    margin-top: 15px;
    width: 100%;
    height: 660px;
    box-shadow: 0px 8px 16px 0px rgba(65, 75, 224, 0.1);
    display: flex;
    > div {
      flex: 1;
      padding: 30px 50px;
      box-sizing: border-box;
      border-left: 1px solid rgba(224, 234, 241, 1);
      &:hover {
        border: 1px solid #3bc492;
        > div {
          span.tobuy {
            background-color: #3bc492;
            color: #fff;
          }
        }
      }
      > div {
        height: 260px;
        border-bottom: 1px solid rgba(224, 234, 241, 1);
        display: flex;
        flex-direction: column;
        text-align: center;
        padding: 18px 0;
        h4 {
          font-size: 22px;
        }
        h2 {
          padding: 28px 0;
          font-size: 28px;
        }
        p {
          padding: 3px;
          font-size: 14px;
        }
        .tobuy {
          cursor: pointer;
          display: block;
          width: 100px;
          height: 40px;
          line-height: 40px;
          margin: 0 auto;
          text-align: center;
          border-radius: 23px;
          font-size: 14px;
          font-weight: 600;
          color: rgba(59, 196, 146, 1);
          border: 1px solid rgba(59, 196, 146, 1);
        }
      }
    }
  }
}
.notice-box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.notice {
  width: 200px;
  text-align: center;
  box-shadow: 3px 4px 5px 5px rgba(167, 188, 169, 0.31);
  position: absolute;
  border-radius: 10px;
  left: 20px;
  background: #fff;
  top: -40px;
  display: none;
}
.wenhao {
  height: 15px;
}
.notice-box:hover > .notice {
  display: block;
}
/deep/.el-tabs__content {
  padding-bottom: 0px;
}
.index {
  padding-bottom: 0px;
}
.info {
  line-height: 25px;
  background: #fff;
  padding: 5px 5px;
  border: 1px solid #e0eaf1;
}
.info-title {
  display: flex;
  align-items: center;
  justify-content: left;
}
.info-title img {
  height: 15px;
  margin-right: 5px;
}
</style>
